import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup as MuiRadioGroup,
  styled,
} from "@mui/material";
import clsx from "clsx";
import NormalText from "../Typography/NormalText";

const LabelStyled = styled(FormControlLabel)(() => ({
  ".MuiFormControlLabel-label": {
    fontSize: "14px",
    fontWeight: 400,
  },
}));

const RadioGroupStyled = styled(MuiRadioGroup)({
  ".MuiButtonBase-root.MuiRadio-root": {
    paddingTop: "2px",
    paddingBottom: "2px",
    paddingRight: "4px",
    "&:hover": {
      backgroundColor: "unset",
    },
  },
});

const FormControlStyled = styled(FormControl)({
  "& .view-text": {
    lineHeight: "24px",
    paddingLeft: "12px",
  },
});

const RadioGroupUnstyled = ({
  className,
  classNames = {}, // { viewText, group, label }
  direction = "row",
  id,
  label,
  labelPlacement = "end", // 'start' | 'end' | 'top' | 'bottom'
  name,
  onChange,
  options = [],
  value,
  isViewMode,
  isDisabled,
}) => {
  const foundValue = options.find((option) => option.value === value)?.label;

  return (
    <FormControlStyled className={className}>
      {isViewMode ? (
        <NormalText className={clsx("view-text", classNames.viewText)}>
          {foundValue || "-"}
        </NormalText>
      ) : (
        <RadioGroupStyled
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          row={direction === "row"}
          className={clsx("group", classNames.group)}
        >
          {options.map((option) => (
            <LabelStyled
              key={option.value}
              value={option.value}
              label={option.label}
              control={<Radio size="small" />}
              labelPlacement={labelPlacement}
              className={clsx("label", classNames.label)}
              disabled={isDisabled || option?.isDisabled}
            />
          ))}
        </RadioGroupStyled>
      )}
    </FormControlStyled>
  );
};

const RadioGroup = styled(RadioGroupUnstyled)({});

export default RadioGroup;
